import type { SocialBarIconProps } from '../SocialBar/types';

export interface CopyUrlButtonProps extends Omit<SocialBarIconProps, 'icon'> {
  icon?: SocialBarIconProps['icon']; // make it optional
  url: string;
  successText: string;
  tooltipText: string;
}

export type RenderSuccessProps = Pick<CopyUrlButtonProps, 'successText'> & {
  mobile: boolean;
};

export type GetButtonIconProps = Pick<
  CopyUrlButtonProps,
  'successText' | 'icon'
> & {
  mobile: boolean;
  success: boolean;
};
